<template>
  <div>
    <div class="homeFooter">
      <span>一丁工作室 / 1DING-LAB</span>
      <span>&nbsp;&nbsp;&copy;2019</span>
      <span class="show-xs-and-up-only">&nbsp;&nbsp;&nbsp;沪ICP备19000366号-1</span>
    </div>
    <!-- 支付 -->
    <el-row v-if="showUserCenter" class="drawer">
      <el-col :span="14">
        <div style="background-color:white">
          <userCenter :table_height="table_height" class="contents  hideScrollbar" />
        </div>
      </el-col>
      <el-col :span="10">
        <div class="cover" @click="showUserCenter=false">
        </div>
      </el-col>
    </el-row>
  </div>
</template>


<script>
  import Bus from "@/misc/bus.js";
  import userCenter from "@/components/user/userCenter.vue";
  export default {
    name: "homeHeader",
    data() {
      return {
        showUserCenter: false,
        table_height: 300
      };
    },
    components: {
      userCenter
    },
    computed: {
      userInfo() {
        return this.$store.state.users.userInfo;
      },
    },
    mounted() {
      // 百度流量统计
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?75c04632a91b6c4876d6f431e49fd802";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();
      // 是否显示用户中心
      Bus.$on("showUserCenter", e => {
        this.showUserCenter = e;
      });
    },
    methods: {
      logout() {
        this.$store.dispatch("users/logout");
      }
    }
  };
</script>

<style scoped>
  .homeFooter {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #aa0000;
    color: #efefef;
    height: 0.3rem;
    line-height: 0.3rem;
    padding-top: 0.02rem;
    width: 100%;
    text-align: center;
    letter-spacing: 0.01rem;
    z-index: 99;
  }

  .homeFooter .drawer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    color: #2f2f2f;
    letter-spacing: 0.01rem;
    z-index: 200;
  }

  .homeFooter .contents {
    height: 100vh;
    padding: 0.1rem;
    box-shadow: 0.02rem 0.01rem #ddd;
  }

  .homeFooter .cover {
    width: 100%;
    height: 100vh;
    background-color: gray;
    opacity: 0.5;
  }
</style>